/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type GetOrganizationRemoteSessionClientDelegationStatusSecurity = {
  sessionHeaderGramSession?: string | undefined;
};

export type GetOrganizationRemoteSessionClientDelegationStatusRequest = {
  /**
   * The remote_session_client id.
   */
  id: string;
  /**
   * Session header
   */
  gramSession?: string | undefined;
};

/** @internal */
export type GetOrganizationRemoteSessionClientDelegationStatusSecurity$Outbound =
  {
    "session_header_Gram-Session"?: string | undefined;
  };

/** @internal */
export const GetOrganizationRemoteSessionClientDelegationStatusSecurity$outboundSchema:
  z.ZodMiniType<
    GetOrganizationRemoteSessionClientDelegationStatusSecurity$Outbound,
    GetOrganizationRemoteSessionClientDelegationStatusSecurity
  > = z.pipe(
    z.object({
      sessionHeaderGramSession: z.optional(z.string()),
    }),
    z.transform((v) => {
      return remap$(v, {
        sessionHeaderGramSession: "session_header_Gram-Session",
      });
    }),
  );

export function getOrganizationRemoteSessionClientDelegationStatusSecurityToJSON(
  getOrganizationRemoteSessionClientDelegationStatusSecurity:
    GetOrganizationRemoteSessionClientDelegationStatusSecurity,
): string {
  return JSON.stringify(
    GetOrganizationRemoteSessionClientDelegationStatusSecurity$outboundSchema
      .parse(getOrganizationRemoteSessionClientDelegationStatusSecurity),
  );
}

/** @internal */
export type GetOrganizationRemoteSessionClientDelegationStatusRequest$Outbound =
  {
    id: string;
    "Gram-Session"?: string | undefined;
  };

/** @internal */
export const GetOrganizationRemoteSessionClientDelegationStatusRequest$outboundSchema:
  z.ZodMiniType<
    GetOrganizationRemoteSessionClientDelegationStatusRequest$Outbound,
    GetOrganizationRemoteSessionClientDelegationStatusRequest
  > = z.pipe(
    z.object({
      id: z.string(),
      gramSession: z.optional(z.string()),
    }),
    z.transform((v) => {
      return remap$(v, {
        gramSession: "Gram-Session",
      });
    }),
  );

export function getOrganizationRemoteSessionClientDelegationStatusRequestToJSON(
  getOrganizationRemoteSessionClientDelegationStatusRequest:
    GetOrganizationRemoteSessionClientDelegationStatusRequest,
): string {
  return JSON.stringify(
    GetOrganizationRemoteSessionClientDelegationStatusRequest$outboundSchema
      .parse(getOrganizationRemoteSessionClientDelegationStatusRequest),
  );
}
